module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.paginationData.total) ? _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.paginationData.pageIndex,
      "page-size": _vm.paginationData.pageSize,
      "page-sizes": _vm.paginationData.pageSizes ? _vm.paginationData.pageSizes : _vm.pageSizes,
      "layout": _vm.paginationData.layOuts ? _vm.paginationData.layOuts : _vm.layOuts,
      "total": _vm.paginationData.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c54c34b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customPagination/index.vue
// module id = 627
// module chunks = 50